/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export const nameRegex = /^[A-Za-z\W]+$/;

/**
 * Validates a plain text name using a regular expression.
 *
 * @param {string | undefined} name - The name to be validated.
 * @return {string | undefined} - Returns an error message if the name is invalid, otherwise undefined.
 */
export const isInvalidName = (name: string | undefined) => {
  if (!name?.length) {
    return 'Name is required';
  } else if (!nameRegex.test(name)) {
    return 'Please enter a valid name';
  } else {
    return undefined;
  }
};
